import type { Track } from '../../api.js';

function relativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  const now = Date.now();
  const diff = Math.max(0, now - then);
  const s = Math.floor(diff / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}

export default function CancelledCard({ tracks }: { tracks: Track[] }) {
  const cancelled = tracks
    .filter((t) => t.state === 'CANCELLED')
    .sort((a, b) => new Date(b.cancelled_at ?? b.updated_at).getTime() - new Date(a.cancelled_at ?? a.updated_at).getTime());

  if (cancelled.length === 0) return null;

  return (
    <div className="conductor-card">
      <div className="conductor-card-header">
        <span className="conductor-card-title">Cancelled</span>
      </div>
      <div className="requests-list">
        {cancelled.map((track) => (
          <div className="request-row" key={track.id}>
            <div className="request-row-main">
              <div className="request-row-title">{track.title}</div>
              <div className="request-row-chips">
                {track.cancelled_at && <span>{relativeTime(track.cancelled_at)}</span>}
              </div>
              <div className="request-row-note">
                {track.cancel_reason ?? '(no reason recorded — pre-dates this feature)'}
              </div>
              {track.last_session_outcome && (
                <div className="request-row-note">last session: {track.last_session_outcome}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
